import { lazy } from 'react';

const SelfBooking = {
  PreviewPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/PreviewPage.tsx')),
  CampaignPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/CampaignPage.tsx')),
  PositionPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/PositionPage.tsx')),
  HistoryPage: lazy(() => import('src/scenes/SelfBookingTool/scenes/HistoryPage.tsx')),
};

export default SelfBooking;
